/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// import { pxToEm } from 'utils/styles';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// STRUCTURE STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default {
	structure: {
		width: '100%',
		height: '100%'
	}
};